module.exports = __webpack_public_path__ + "img/mag (5).93f09dfb.png";